module.exports = __webpack_public_path__ + "d8505c88f56e.560eb55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/d8505c88f56e.png
// module id = q/Zp
// module chunks = 1